import Vue from 'vue'
import AscTextFieldInput from '@/components/atoms/AscTextFieldInput'

export default Vue.extend({
  components: {
    AscTextFieldInput,
  },

  data: function () {
    return {
      currentValue: '',
    }
  },

  beforeMount() {
    let filterText = ''

    if (filterText === '') {
      // Set to none
      this.currentValue = ''
      this.handleInput()
    } else {
      this.currentValue = filterText
      this.handleInput()
    }
  },

  methods: {
    handleInput() {
      if (this.currentValue === '') {
        this.params.parentFilterInstance(instance => {
          instance.myMethodForTakingValueFromFloatingFilter(null)
        })
        return
      }

      this.params.parentFilterInstance(instance => {
        instance.myMethodForTakingValueFromFloatingFilter(this.currentValue)
      })
    },

    onParentModelChanged(parentModel) {
      // When the filter is empty we will receive a null value here
      if (!parentModel) {
        this.currentValue = ''
      } else {
        this.currentValue = parentModel
      }
    },
  },

  template: `<asc-text-field-input
  type="text"
  v-model="currentValue"
  :dense="true"
  :hide-details="true"
  @input="handleInput" 
  style="margin-bottom: 0.5em;" />`,
})
